import { onMounted, ref, computed } from 'vue'
import { getImage } from '@/utils'
import { useI18n } from 'vue-i18n'
import { useGetLanguage } from '@/hooks/useGetLanguage'

export const usePageScript = () => {
  let { t, locale } = useI18n()
  let reginObj = computed(() => {
    return (
      {
        zh: [
          '美国',
          '墨西哥',
          '法国',
          '印度尼西亚',
          '日本',
          '德国',
          '菲律宾',
          '韩国',
          '爱尔兰',
          '马来西亚',
          '泰国',
          '意大利',
          '巴西',
          '英国',
          '巴基斯坦',
          '新加坡',
          '澳大利亚',
          '俄罗斯',
          '越南',
          '孟加拉国',
          '土耳其',
          '加拿大',
          '埃及',
          '西班牙',
        ],

        en: [
          'United States',
          'Mexico',
          'France',
          'Indonesia',
          'Japan',
          'Germany',
          'Philippines',
          'South Korea',
          'Ireland',
          'Malaysia',
          'Thailand',
          'Italy',
          'Brazil',
          'United Kingdom',
          'Pakistan',
          'Singapore',
          'Australia',
          'Russia',
          'Vietnam',
          'Bangladesh',
          'Turkey',
          'Canada',
          'Egypt',
          'Spain',
        ],
      } as any
    )?.[locale.value]
  })
  // 国家
  let reginArr = ref(reginObj.value)

  // tool 工具
  let tools = ref([
    {
      icon: getImage('../assets/images/influenbase-tool-1.png'),
      title: t('home.text10'),
      desc: t('home.text11'),
      img:
        locale.value == 'zh'
          ? getImage('../assets/images/influenbase-tool-img1.png')
          : getImage('../assets/images/influenbase-tool-img1.webp'),
      class: locale.value == 'en' ? 'h-[88px]' : '',
      descClass: locale.value == 'en' ? 'h-[140px]' : '',
    },
    {
      icon: getImage('../assets/images/influenbase-tool-2.png'),
      title: t('home.text12'),
      desc: t('home.text13'),
      img:
        locale.value == 'zh'
          ? getImage('../assets/images/influenbase-tool-img2.png')
          : getImage('../assets/images/influenbase-tool-img2.webp'),
      class: locale.value == 'en' ? 'h-[88px]' : '',
    },
    {
      icon: getImage('../assets/images/influenbase-tool-3.png'),
      title: t('home.text55'),
      desc: t('home.text56'),
      img: getImage('../assets/images/influenbase-tool-img3.png'),
      class: locale.value == 'en' ? 'h-[88px]' : '',
      descClass: locale.value == 'en' ? 'h-[160px]' : '',
    },
    {
      icon: getImage('../assets/images/influenbase-tool-4.png'),
      title: t('home.text14'),
      desc: t('home.text15'),
      img: getImage('../assets/images/influenbase-tool-img4.png'),
      class: locale.value == 'en' ? 'h-[88px]' : '',
      descClass: locale.value == 'en' ? 'h-[160px]' : '',
    },
    {
      icon: getImage('../assets/images/influenbase-tool-5.png'),
      title: t('home.text16'),
      desc: t('home.text17'),
      img: getImage('../assets/images/influenbase-tool-img5.png'),
      descClass: locale.value == 'en' ? 'h-[100px]' : '',
    },
    {
      icon: getImage('../assets/images/influenbase-tool-6.png'),
      title: t('home.text18'),
      desc: t('home.text19'),
      img:
        locale.value == 'zh'
          ? getImage('../assets/images/influenbase-tool-img6.png')
          : getImage('../assets/images/influenbase-tool-img6.webp'),
      descClass: locale.value == 'en' ? 'h-[100px]' : '',
    },
  ])

  // 效果
  let effectData = ref([
    {
      text: t('home.text20'),
      class: 'fw-600',
    },
    {
      text: t('home.text21'),
      class: 'bg1 border-top fw-600',
    },
    {
      text: t('home.text22'),
      class: 'bg2 border-top fw-600',
      icon: getImage('../assets/images/influenbase-effect.png'),
    },
    {
      text: t('home.text23'),
      class: 'fw-600',
    },
    {
      text: t('home.text24'),
      class: 'fw-600',
    },
    {
      text: t('home.text25'),
      class: 'fw-600',
    },
    {
      text: t('home.text26'),
      class: 'bg1',
    },
    {
      text: t('home.text27'),
      class: 'bg2',
    },
    {
      text: t('home.text28'),
      class: '',
    },
    {
      text: t('home.text29'),
      class: '',
    },
    {
      text: t('home.text30'),
      class: 'fw-600',
    },
    {
      text: t('home.text31'),
      class: 'bg1',
    },
    {
      text: t('home.text32'),
      class: 'bg2',
    },
    {
      text: t('home.text33'),
      class: '',
    },
    {
      text: t('home.text34'),
      class: '',
    },
    {
      text: t('home.text35'),
      class: 'fw-600',
    },
    {
      text: t('home.text36'),
      class: 'bg1 border-bottom',
    },
    {
      text: t('home.text37'),
      class: 'bg2 border-bottom',
    },
    {
      text: t('home.text38'),
      class: '',
    },
    {
      text: t('home.text39'),
      class: '',
    },
  ])

  // 轮播
  let carouselData = ref([
    t('home.text41'),
    t('home.text42'),
    t('home.text43'),
    t('home.text44'),
    t('home.text45'),
    t('home.text46'),
  ])

  // 打开弹窗
  const showDialog = ref(false)
  function handleOpen() {
    showDialog.value = true
  }

  // 下载插件
  const { extensionUrl, toolImg } = useGetLanguage()
  function handleDownload() {
    window.open(extensionUrl.value)
  }

  return {
    reginObj,
    carouselData,
    tools,
    effectData,
    reginArr,
    showDialog,
    handleDownload,
    handleOpen,
    toolImg,
    locale,
    extensionUrl,
  }
}
